import type { RedoMerchantRpcClient } from "@redotech/merchant-sdk/rpc/client";
import type { Team } from "@redotech/redo-team-common/team";

export const ENABLE_AI_AUTOMATION_PARAM = "enableAiAutomation";

type UpdatePickedSettings = RedoMerchantRpcClient["updatePickedSettings"];

interface DisputesSettingsRpcClient {
  updatePickedSettings: (
    input: Parameters<UpdatePickedSettings>[0],
  ) => ReturnType<UpdatePickedSettings>;
}

export async function enableDisputesAiEvidenceAutomation({
  rpcClient,
  teamId,
}: {
  rpcClient: DisputesSettingsRpcClient;
  teamId: Team["_id"];
}) {
  await rpcClient.updatePickedSettings({
    teamId,
    settings: { "disputes/automateEvidenceEnabled": true },
  });
}
